// @flow

import React, { type Node } from 'react';
import { getLocalTaxFromCodeSubstring, useCurrentReceipt } from '@tectonics/prs/receipts';
import { getMoneyFormat } from '../../../commons/money-format';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { Tooltip } from './tooltip';

import {
  SideDisplayValueItem,
  SideDisplayValueItemTitle,
  SideDisplayValueItemValue,
} from './../side-display-values';

export function DisplayArgentineIIBB(): Node {
  const receipt = useCurrentReceipt();
  const arIIBB = getLocalTaxFromCodeSubstring(receipt, 'AR_IIBB_');
  const formatAmount = amountToCurrencyString(getMoneyFormat('ar'));

  if (!arIIBB) return null;

  var percentage = 0;

  if (arIIBB.rate) {
    percentage = parseFloat(arIIBB.rate) * 100;
  }

  if (percentage == 0) return null;

  return (
    <SideDisplayValueItem data-testid="display_argentine_iibb">
      <SideDisplayValueItemTitle>
        IIBB ({percentage}%) <Tooltip />
      </SideDisplayValueItemTitle>
      <SideDisplayValueItemValue>
        {formatAmount(arIIBB.amount)}
      </SideDisplayValueItemValue>
    </SideDisplayValueItem>
  );
}
